var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.75,
  clipPath: "url(#notification_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.503 15.39a5.28 5.28 0 0 1-1.903-4.058V9.125c0-2.786-2.091-5.092-4.8-5.478v-.855A.796.796 0 0 0 12 2c-.442 0-.8.354-.8.792v.855c-2.71.386-4.8 2.692-4.8 5.478v2.207a5.29 5.29 0 0 1-1.91 4.064c-.312.263-.49.647-.49 1.052 0 .764.628 1.385 1.4 1.385h13.2c.772 0 1.4-.621 1.4-1.385 0-.405-.178-.789-.497-1.059M12 21a3 3 0 0 0 2.94-2.375H9.06A3 3 0 0 0 12 21"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "notification_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgNotification;